var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7718_47520)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.428571 1.07153C0.191878 1.07153 0 1.26341 0 1.5001V2.58418V10.5001C0 10.7368 0.191878 10.9287 0.428571 10.9287H11.5714C11.8081 10.9287 12 10.7368 12 10.5001V2.58825C12 2.58554 12 2.58282 12 2.58011V1.5001C12 1.26341 11.8081 1.07153 11.5714 1.07153H0.428571ZM11.1429 2.38529V1.92868H0.857143V2.38527L5.72355 6.49201L5.72358 6.49203C5.8009 6.5573 5.89882 6.5931 6.00001 6.5931C6.10119 6.5931 6.19912 6.5573 6.27644 6.49203L6.27647 6.49201L11.1429 2.38529ZM0.857143 3.50684V10.0715H11.1429V3.50686L6.8293 7.14705L6.82927 7.14707C6.5973 7.34285 6.30355 7.45024 6.00001 7.45024C5.69647 7.45024 5.40272 7.34285 5.17075 7.14707L5.17072 7.14705L0.857143 3.50684Z",
    fill: "black",
    fillOpacity: 0.52
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7718_47520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEnvelope);
export default __webpack_public_path__ + "static/media/email-envelope.89e2f814a274dace67992f6cae93fce1.svg";
export { ForwardRef as ReactComponent };